import { PageLayout } from '../layout/PageLayout'
import { Title } from '@app/components/core/typography/Title'

export const Events = () => {
  return (
    <PageLayout>
      <Title.H1>Events</Title.H1>
    </PageLayout>
  )
}
